import type { TrainingLessonSpecific } from './trainingLessonUi';

export const highPriest2ShepherdingEs: TrainingLessonSpecific = {
  intro:
    'El Sumo Sacerdote cuida almas, no números. Muchas crisis en el barrio no son doctrinales: son relacionales (orgullo, malentendidos, cansancio). Un buen líder espiritual no "gana discusiones"; gana confianza.',
  objectives: [
    'Aprender el enfoque "pastoral" del sacerdocio: cuidar almas, no números.',
    'Fortalecer unidad y paz en la Iglesia local (evitar chismes/contención).',
    'Entender cómo dar consejo con mansedumbre y claridad.',
    'Desarrollar discernimiento y prudencia (qué decir, cuándo, y a quién).',
    'Crear un plan de servicio espiritual de 30 días (simple pero real).',
  ],
  briefHeading: 'Pastoreo en breve',
  briefBody:
    'Escuchar antes de hablar, orar por discernimiento, y buscar paz sin evadir la verdad. El cuidado del rebaño es trabajo diario de caridad.',
  scriptures: [
    { ref: 'Juan 21:15–17', text: 'Apacienta mis ovejas.' },
    { ref: 'Mosíah 18:8–10', text: 'Llorar con los que lloran, consolar a los que necesitan consuelo.' },
    { ref: 'DyC 121:43–44', text: 'Corrección seguida de amor y confianza.' },
    { ref: 'Efesios 4:29', text: 'Hablar para edificar, no corromper.' },
    { ref: 'Alma 7:11–12', text: 'Cristo comprende para socorrer.' },
  ],
  didYouKnow: [
    'Muchas crisis en el barrio no son doctrinales: son relacionales (orgullo, malentendidos, cansancio).',
    'Un buen líder espiritual no "gana discusiones"; gana confianza.',
  ],
  practiceItems: [
    'Identificar 1 fuente de contención que tú puedas cortar (chisme, sarcasmo, crítica)',
    'Practicar una frase de paz: "hablemos para edificar, no para dividir"',
    'Visitar o llamar a 1 persona que esté debilitándose (con respeto, sin presión)',
    'Preparar 1 consejo simple (1 idea + 1 escritura + 1 invitación)',
    'Hacer un servicio "invisible" (nadie tiene que saber)',
    'Plan de 30 días: escoger 1 hábito de cuidado (contacto semanal, oración diaria por alguien, etc.)',
  ],
  reflectionQuestions: [
    '¿Qué me hace reaccionar con orgullo cuando aconsejo?',
    '¿Cómo puedo ser más prudente con mis palabras?',
    '¿A quién debo cuidar sin juzgar?',
  ],
  actionText:
    'Unidad primero: durante 7 días, elimina 1 hábito que cause contención y reemplázalo por 1 hábito que edifique.',
};
